import React from 'react'

function BuyPopup(props) {
    const handleClose=()=>{
        props.setShowModal(false);
    }
  return (
    <div className={`popop ${props.showModal?"active":""}`}>
    <div className='text-end'>
         <i className="bi bi-x-lg close_icon" onClick={handleClose}></i>
         </div>
         <div className='text-dark'>
          <p className='fontsizep'><b>SCOTTY on Ethereum Holders Get a 10% Bonus! No Verification, Just Vibes.</b></p>
          <p>The SCOTTY community has been running strong for over 2 years—built on memes, trust, and pure degen energy. We don’t do boring verifications here. If you say you’re a SCOTTY holder, we believe you. No questions asked. No blockchain forensics. Just straight-up trust between fellow degens.
          </p>
          <p className='fontsizep'> <b>💰 Stack More, Earn More:</b></p>
          <p>🔥 Buy $2,000+ and get 15% bonus</p>
          <p>🚀 Buy $3,500+ and get 20% bonus</p>
         </div>
            <div className="popop_box">
              <p>You want {props.bonus}% bonus</p>
              <button className="btn btn_2 " onClick={()=>{props.normalBuy()}} disabled={props.disable}>Skip And Buy</button>
            </div> 
            {props.extrabonus &&  <div className="popop_box">
            <p>If You want {props.extrabonus}% bonus</p> 
            <button className="btn btn_2 " disabled={props.disable} onClick={()=>{props.extraBuy()}}>Add {props.extraAmount} {props.currencyName} And Buy</button>
             </div>}
            {props.maxExtrabonus &&  <div className="popop_box">
            <p>If You want {props.maxExtrabonus}% bonus</p> 
            <button className="btn btn_2 " disabled={props.disable} onClick={()=>{props.maxExtraBuy()}}>Add {props.maxExtraAmount} {props.currencyName} And Buy</button>
             </div>} 
    </div>
  )
}

export default BuyPopup